import styled from 'styled-components';

/* ===== Header base ===== */
export const HeadContainer = styled.header`
    position: sticky;
    top: 0;
    z-index: 130;
    width: 100%;
    height: 64px;
    /* background: rgba(20, 24, 32, 0.28); */
    /* ★ Gradient Dim 배경 */
    /* background: linear-gradient(
        to bottom,
        rgba(20, 24, 32, 0.55) 0%,
        rgba(20, 24, 32, 0.35) 30%,
        rgba(20, 24, 32, 0.00) 100%
    ); */
    /* backdrop-filter: saturate(150%) blur(6px); */
    color: #fff;
`;

export const HeaderWrapper = styled.div`
    max-width: 1280px;
    height: 100%;
    margin: 0 auto;
    padding: 0 16px 0 26px;
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 12px;
`;

export const HeaderLogo = styled.div`
    display: flex;
    align-items: center;
    a {
        display: inline-flex;
    }
`;

/* 가운데 메뉴(데스크톱 전용) */
export const Nav = styled.ul`
    display: none;
    @media (min-width: 960px) {
        display: flex;
        align-items: center;
        gap: 24px;
        justify-self: center;
    }
`;

/* 우측 묶음: 언어 + 햄버거 */
export const HeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    justify-self: end;
`;

export const MenuItem = styled.li`
    position: relative;
    list-style: none;
    font-size: 14px;

    > a {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 12px 16px;
        min-height: 44px;
        font-weight: 600;
        letter-spacing: 0.03em;
        border-radius: 3px;
        transition: background 0.15s ease, transform 0.15s ease;
    }
    &:hover > a,
    &:focus-within > a,
    &[data-open] > a {
        background: rgba(255, 255, 255, 0.08);
        transform: translateY(-1px);
    }
`;

export const Caret = styled.span`
    font-size: 12px;
    line-height: 1;
    transform: translateY(1px);
`;

export const Dropdown = styled.ul`
    position: absolute;
    left: 0;
    top: calc(100% + 8px);
    z-index: 140;
    transform: translateY(6px);
    min-width: 200px;
    padding: 12px;
    border-radius: 5px;
    background: rgba(12, 16, 24, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
    display: grid;
    gap: 8px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.18s ease, transform 0.18s ease;
    backdrop-filter: blur(10px);

    &.open {
        opacity: 1;
        pointer-events: auto;
        transform: translateY(0);
    }

    li {
        list-style: none;
    }
    a {
        display: block;
        padding: 12px 14px;
        border-radius: 5px;
        font-size: 13px;
        white-space: nowrap;
        transition: background 0.12s ease, transform 0.1s ease;
    }
    a:hover,
    a:focus {
        background: rgba(255, 255, 255, 0.1);
        transform: translateX(2px);
    }
`;

/* 언어(데스크톱) */
export const HeaderLanguage = styled.div`
    display: none;
    @media (min-width: 960px) {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        margin-right: 6px;
        span {
            cursor: pointer;
            font-weight: 700;
            opacity: 0.85;
        }
        .divider {
            opacity: 0.6;
            cursor: default;
        }
        .active {
            color: #ff8a00;
            opacity: 1;
        }
    }
`;

/* 햄버거: 모바일에서만 보임, 굵기 일정(3px) + 둥근 캡 */
export const Hamburger = styled.button`
    width: 44px;
    height: 44px;
    border: 0;
    background: transparent;
    cursor: pointer;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    span {
        width: 30px;
        height: 3px;
        background: #fff;
        border-radius: 3px;
        transition: transform 0.18s, opacity 0.18s;
    }
    &.open span:nth-child(1) {
        transform: translateY(8px) rotate(45deg);
    }
    &.open span:nth-child(2) {
        opacity: 0;
    }
    &.open span:nth-child(3) {
        transform: translateY(-8px) rotate(-45deg);
    }
    @media (min-width: 960px) {
        display: none;
    }
`;

/* 모바일 드로어: 오버레이 + 패널 분리 */
export const DrawerOverlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 120;
    background: rgba(0, 0, 0, 0.32);
    backdrop-filter: blur(2px) saturate(110%);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.18s ease;
    &.show {
        opacity: 1;
        pointer-events: auto;
    }
`;

export const DrawerPanel = styled.aside`
    position: fixed;
    top: 0;
    right: 0;
    z-index: 125;
    width: min(420px, 86vw);
    height: 100dvh;
    transform: translate3d(100%, 0, 0);
    background: rgba(12, 16, 24, 0.94);
    backdrop-filter: blur(10px);
    box-shadow: -10px 0 30px rgba(0, 0, 0, 0.35);
    transition: transform 0.24s cubic-bezier(0.2, 0.8, 0.2, 1);
    will-change: transform;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    &.open {
        transform: translate3d(0, 0, 0);
    }

    .head {
        height: 64px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        button {
            width: 44px;
            height: 44px;
            font-size: 20px;
            color: #fff;
            background: transparent;
            border: 0;
        }
    }

    .list {
        flex: 1;
        overflow: auto;
        overscroll-behavior: contain;
        -webkit-overflow-scrolling: touch;
        padding: 8px 12px 16px;
    }
    .item {
        border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    }
    .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .row > a {
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        padding: 14px 4px;
        min-height: 44px;
    }
    .row > button {
        color: #fff;
        background: transparent;
        border: 0;
        width: 44px;
        height: 44px;
        font-size: 18px;
    }

    .submenu {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.22s ease;
        padding-left: 8px;
    }
    .submenu.open {
        max-height: 400px;
    }
    .submenu li a {
        display: block;
        padding: 12px 0;
        color: #fff;
        opacity: 0.95;
    }

    .lang {
        display: flex;
        gap: 8px;
        justify-content: flex-end;
        padding: 12px;
        border-top: 1px solid rgba(255, 255, 255, 0.06);
    }
    .lang button {
        border: 0;
        background: rgba(255, 255, 255, 0.12);
        color: #fff;
        font-weight: 700;
        border-radius: 3px;
        padding: 10px 14px;
        cursor: pointer;
    }
    .lang .active {
        background: #ff8a00;
    }

    .row > button.acc {
        color: #fff;
        background: transparent;
        border: 0;
        width: 44px;
        height: 44px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px; /* 터치감 좋게 라운드 */
    }
    /* .row > button.acc:active {
        background: rgba(255, 255, 255, 0.08);
    } */

    /* 케럿 아이콘 */
    .row > button.acc .chev {
        width: 18px;
        height: 18px;
        fill: none;
        stroke: #fff;
        stroke-width: 2;
        transition: transform 0.22s ease;
        transform: rotate(0deg); /* ▼ */
    }
    .row > button.acc.open .chev {
        transform: rotate(180deg); /* ▲ */
    }

    /* 아코디언 전환 개선: 높이+투명도+살짝 슬라이드 */
    .submenu {
        max-height: 0;
        overflow: hidden;
        opacity: 0;
        transform: translateY(-4px);
        transition: max-height 0.28s ease, opacity 0.18s ease, transform 0.22s ease;
        padding-left: 8px;
    }
    .submenu.open {
        max-height: 480px; /* 충분히 크게 */
        opacity: 1;
        transform: translateY(0);
    }
    .submenu li a {
        display: block;
        padding: 12px 0;
        color: #fff;
        opacity: 0.95;
    }
    .submenu li::marker {
        content: '';
    }
`;
